import { Component, signal } from '@angular/core';
import { AppScope, currentAppScope } from '../../core/scope/app-scope';
import { OrganizationTaskInboxComponent } from './organization-task-inbox.component';
import { WorkflowTasksComponent } from './workflow-tasks.component';

@Component({
  standalone: true,
  selector: 'ain-workflow-tasks-entry',
  imports: [WorkflowTasksComponent, OrganizationTaskInboxComponent],
  template: `
    @if (isOrganizationScope()) {
      <ain-organization-task-inbox />
    } @else {
      <ain-workflow-tasks />
    }
  `
})
export class WorkflowTasksEntryComponent {
  readonly appScope = signal<AppScope>(currentAppScope());

  isOrganizationScope(): boolean {
    return this.appScope() === 'organization';
  }
}

